import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';

import { deskTopTextStyles, mobileTextStyles } from '../../styles/text-styles/';

const StyledHeading0 = styled.h1`
  font-size: ${mobileTextStyles['heading0']['fontSize']};
  line-height: ${mobileTextStyles['heading0']['lineHeight']};
  color: ${mobileTextStyles['heading0']['color']};
  font-weight: ${mobileTextStyles['heading0']['fontWeight']};
`;

const StyledHeading1 = styled.h1`
  font-size: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading1']['fontSize']
      : deskTopTextStyles['heading1']['fontSize']};
  line-height: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading1']['lineHeight']
      : deskTopTextStyles['heading1']['lineHeight']};
  color: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading1']['color']
      : deskTopTextStyles['heading1']['color']};
  font-weight: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading1']['fontWeight']
      : deskTopTextStyles['heading1']['fontWeight']};
`;

const StyledHeading2 = styled.h2`
  font-size: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading2']['fontSize']
      : deskTopTextStyles['heading2']['fontSize']};
  line-height: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading2']['lineHeight']
      : deskTopTextStyles['heading2']['lineHeight']};
  color: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading2']['color']
      : deskTopTextStyles['heading2']['color']};
  font-weight: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading2']['fontWeight']
      : deskTopTextStyles['heading2']['fontWeight']};
`;

const StyledHeading3 = styled.h3`
  font-size: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading3']['fontSize']
      : deskTopTextStyles['heading3']['fontSize']};
  line-height: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading3']['lineHeight']
      : deskTopTextStyles['heading3']['lineHeight']};
  color: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading3']['color']
      : deskTopTextStyles['heading3']['color']};
  font-weight: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading3']['fontWeight']
      : deskTopTextStyles['heading3']['fontWeight']};
`;

const StyledHeading4 = styled.h4`
  font-size: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading4']['fontSize']
      : deskTopTextStyles['heading4']['fontSize']};
  line-height: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading4']['lineHeight']
      : deskTopTextStyles['heading4']['lineHeight']};
  color: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading4']['color']
      : deskTopTextStyles['heading4']['color']};
  font-weight: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading4']['fontWeight']
      : deskTopTextStyles['heading4']['fontWeight']};
`;

const StyledHeading5 = styled.h5`
  font-size: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading5']['fontSize']
      : deskTopTextStyles['heading5']['fontSize']};
  line-height: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading5']['lineHeight']
      : deskTopTextStyles['heading5']['lineHeight']};
  color: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading5']['color']
      : deskTopTextStyles['heading5']['color']};
  font-weight: ${(props) =>
    props.isMobile
      ? mobileTextStyles['heading5']['fontWeight']
      : deskTopTextStyles['heading5']['fontWeight']};
`;

const HeadingVariants = {
  h0: StyledHeading0,
  h1: StyledHeading1,
  h2: StyledHeading2,
  h3: StyledHeading3,
  h4: StyledHeading4,
  h5: StyledHeading5,
};

const Heading = ({ type, content, isMobile }) => {
  const HeadingComponent = HeadingVariants[type];

  if (HeadingComponent) {
    return <HeadingComponent isMobile={isMobile}>{content}</HeadingComponent>;
  }

  return null;
};

Heading.propTypes = {
  /**
   * Heading contents
   */
  type: PropTypes.oneOf(['h0', 'h1', 'h2', 'h3', 'h4', 'h5']),
  content: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
};

Heading.defaultProps = {
  type: 'h1',
  isMobile: false,
};

export { Heading };
